import { PlatformInfo } from 'src/app/util/platfrom.info';

export const environment = {
  production: true,
  name: require('../../package.json').name,
  applicationId: require('../../package.json').id,
  version: require('../../package.json').version,
  applicationName: require('../../package.json').applicationName,
  versionCode: require('../../package.json').versionCode,
  proxyApiUrl: window.location.origin,
  placeholder: 'assets/images/placeholder.png',
  platformInfo: {
    'X-Operating-System': new PlatformInfo().detectOSName(),
    'X-Platform': new PlatformInfo().detectBrowserName(),
    'X-Version': require('../../package.json').version.toString(),
    'X-Build-Number': require('../../package.json').versionCode.toString(),
    'X-Platform-Version': new PlatformInfo().detectPlatformVersion()
  },
  defaultChannel: 'NECOM',
  payment: {
    receiverName: 'JiniFix Store',
    approvalRefNo: 'JINIFIX-'
  },
  google: {
    apiKey: 'AIzaSyB3DoBggYszitIbhqyya6_-s_PTfVYti7o',
    analyticsKey: null as string | null
  },

  firebase: {
    apiKey: 'AIzaSyCtQk32r32uwOcvmUnw8DJ9idUN7H-1eVE',
    authDomain: 'com-xlayer-ecom-jompoi.firebaseapp.com',
    projectId: 'com-xlayer-ecom-jompoi',
    storageBucket: 'com-xlayer-ecom-jompoi.firebasestorage.app',
    messagingSenderId: '827908067942',
    appId: '1:827908067942:web:31585e716b0513374953a7',
    measurementId: 'G-E2J4Z6S8F3'
  },

  fcmVapidKey:
    'BA-RuJKE2Xw2updK5a1yitvFa5kBQ9093yDNRpV9vqWZsSZUp2LnNV_gWXyiHBC9pcdku0-eXFgR7tUD85mh__g'
};
